import(/* webpackMode: "eager", webpackExports: ["DiscoveryRightRail"] */ "/workspace/.ci/web-hosting-src/platform/calendar/CalendarSidebarWidget.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GrowthPathTourCoach"] */ "/workspace/.ci/web-hosting-src/platform/hostgrowth/GrowthPathTourCoach.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GrowthPathTourProvider"] */ "/workspace/.ci/web-hosting-src/platform/hostgrowth/GrowthPathTourContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CommunioSidebar"] */ "/workspace/.ci/web-hosting-src/platform/layout/CommunioSidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LegalPageNav"] */ "/workspace/.ci/web-hosting-src/platform/legal/LegalPageNav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavTourCoach"] */ "/workspace/.ci/web-hosting-src/platform/navTour/NavTourCoach.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavTourControlProvider"] */ "/workspace/.ci/web-hosting-src/platform/navTour/NavTourControlContext.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/web/node_modules/next/dist/client/link.js");
